import useMount from '@src/utils/hooks/use-mount';
import { observable, computed } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useEffect } from 'react';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
class SupplierStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  logoSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      allowTouchMove: false,
      slidesPerView: 5,
      spaceBetween: 120,
      freeMode: true,
      speed: 3000,
      loopedSlides: 12,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      }
    }
  });

  introSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: false,
      allowTouchMove: true,
      slidesPerGroup: 4,
      slidesPerView: 4,
      spaceBetween: 40,
      autoplay: false
    }
  });

  @observable indexList = [];

  @observable indexsActive = 0;

  onPrev = () => {
    this.introSwiper?.goPrev();
  };

  onNext = () => {
    this.introSwiper?.goNext();
  };

  @observable arr = [];

  // 保障第一屏logo占满全屏，使组件能无限循环
  @computed
  get logoList() {
    let data = this.arr;
    if (this.arr.length < 7) {
      data = data.concat(data);
    }
    return data;
  }

  goSlide = count => {
    const index = count * 4;
    this.introSwiper?.onChange(index);
  };

  companyList = [];

  @observable mainStore;

  //前往购买

  use() {
    super.use();

    const layerData = useLayerData('part4');
    console.log(layerData, 'layerData');

    useEffect(
      () => {
        if (layerData) {
          this.companyList = layerData.companyList;
          this.arr = layerData.marqueeList;
          console.log(this.arr, 'arr');
        }
      },
      [layerData]
    );

    useEffect(
      () => {
        if (this.companyList.length && this.companyList.length > 4) {
          this.indexList = Array(Math.ceil(this.companyList.length / 4)).fill(1);
        }
      },
      [this.companyList]
    );

    useEffect(
      () => {
        const isEnd = (this.introSwiper.activeIndex + 4) % 4;
        const currentIndex = Math.floor((this.introSwiper.activeIndex + 4) / 4);

        if (isEnd) {
          this.indexsActive = currentIndex + 1;
        } else {
          this.indexsActive = currentIndex;
        }
      },
      [this.introSwiper.activeIndex]
    );

    useMount(() => {});
  }
}

export default SupplierStore;
